import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Button} from '../../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {useAppSelector} from '../../../../../helpers/reduxHelpers';
import {buildSettingsAppsTabUrl} from '../../../../../models/url/settingsUrlHelpers';
import {SettingsAppsTabsEnum} from '../../../../../models/url/settingsUrlModel';
import {InterfaceEventsEnum, trackInterfaceEvent} from '../../../../../services/tracking';
import {getIsUserGlobalAdmin} from '../../../../../store/data/teammates/teammatesSelectors';
import {getHasNewIntegrationsDiscoverability} from '../../../../../store/featureFlags/featureFlagsSelectors';
import {ApplicationCategoryCard} from '../../../../common/applications/applicationCategoryCard';
import {useLinkNavigation} from '../../../../common/navigation/useLinkNavigation';

/*
 * Style.
 */

const StyledButton = styled(Button)`
  margin-top: -16px;
`;

/*
 * Component.
 */

export const SidePanelApplicationsManagerFindMoreBanner: FC = () => {
  const {navigateToLink} = useLinkNavigation();
  const hasNewIntegrationsDiscoverability = useAppSelector(getHasNewIntegrationsDiscoverability);
  const isGlobalAdmin = useAppSelector(getIsUserGlobalAdmin);
  const shouldRenderButton = hasNewIntegrationsDiscoverability || isGlobalAdmin;

  const onNavigateToAllPlugins = () => {
    trackInterfaceEvent(InterfaceEventsEnum.APPS_P4_ALL_PLUGINS_CLICK, {id: 'go-to-all-plugins'});
    if (hasNewIntegrationsDiscoverability) {
      navigateToLink(buildSettingsAppsTabUrl(SettingsAppsTabsEnum.PLUGINS, undefined, undefined, 'p4'));
      return;
    }
    navigateToLink('/settings/integrations/native');
  };

  return (
    <ApplicationCategoryCard
      title={<Trans id="sidepanel-manager-find-more-title">Find more plugins</Trans>}
      description={
        <Trans id="sidepanel-manager-find-more-description">
          Save time and work more efficiently with plugins.
        </Trans>
      }
    >
      {shouldRenderButton && (
        <StyledButton variant={ButtonVariantsEnum.PRIMARY} onClick={onNavigateToAllPlugins}>
          <Trans id="sidepanel-manager-find-more-button-action">Go to all plugins</Trans>
        </StyledButton>
      )}
    </ApplicationCategoryCard>
  );
};
